import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { toObjectMap } from "../../utils";
import { Amenity } from "../models";
import { QUERIES } from "../queries";

type AmenityWithColor = Pick<Amenity, "color" | "id" | "name">;

export function useAmenitiesColorMap(buildingId?: string) {
  const { loading, data, error } = useQuery(QUERIES.AMENITIES_COLORS, {
    variables: {
      buildingId,
    },
  });

  const dataResult: AmenityWithColor[] = useMemo(() => {
    if (data) {
      return data.amenities as AmenityWithColor[];
    }

    return [];
  }, [data]);

  const amenityColorMap = useMemo(() => {
    return toObjectMap(dataResult);
  }, [dataResult]);

  return { loading, amenityColorMap, error };
}
